var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEstimateHub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8126_25749",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8126_25749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 15.5834C10.4513 15.5834 9.13309 15.0405 8.04656 13.9548C6.96002 12.8692 6.41675 11.5513 6.41675 10.0013C6.41675 8.45135 6.95959 7.13309 8.04529 6.04656C9.13097 4.96002 10.4488 4.41675 11.9988 4.41675C13.5488 4.41675 14.867 4.9596 15.9536 6.04529C17.0401 7.13097 17.5834 8.4488 17.5834 9.99879C17.5834 11.5488 17.0405 12.867 15.9548 13.9536C14.8692 15.0401 13.5513 15.5834 12.0013 15.5834ZM6.23887 15.3254C5.07647 14.945 4.14885 14.265 3.45602 13.2853C2.76317 12.3056 2.41675 11.2114 2.41675 10.0025C2.41675 8.7937 2.7597 7.69515 3.4456 6.70687C4.13149 5.71858 5.06258 5.0551 6.23887 4.71644C6.4333 4.67049 6.60878 4.70464 6.76529 4.81889C6.9218 4.93314 7.00006 5.07866 7.00006 5.25546C7.00006 5.36083 6.97591 5.45563 6.9276 5.53985C6.8793 5.62407 6.80196 5.67812 6.69558 5.70198C5.74686 5.99151 4.9771 6.53184 4.38629 7.32298C3.79547 8.1141 3.50006 9.00299 3.50006 9.98964C3.50006 10.9763 3.79547 11.8652 4.38629 12.6563C4.9771 13.4474 5.74686 14.0017 6.69558 14.319C6.78383 14.3629 6.85664 14.4243 6.91402 14.5033C6.97138 14.5823 7.00006 14.6731 7.00006 14.7757C7.00006 14.9626 6.91833 15.1194 6.75487 15.246C6.59141 15.3726 6.41941 15.3991 6.23887 15.3254ZM12.0001 14.5001C13.2501 14.5001 14.3126 14.0626 15.1876 13.1876C16.0626 12.3126 16.5001 11.2501 16.5001 10.0001C16.5001 8.75006 16.0626 7.68756 15.1876 6.81256C14.3126 5.93756 13.2501 5.50006 12.0001 5.50006C10.7501 5.50006 9.68756 5.93756 8.81256 6.81256C7.93756 7.68756 7.50006 8.75006 7.50006 10.0001C7.50006 11.2501 7.93756 12.3126 8.81256 13.1876C9.68756 14.0626 10.7501 14.5001 12.0001 14.5001Z",
    fill: "#4E4E4E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstimateHub);
export default __webpack_public_path__ + "static/media/estimate-hub.000e1f6533c12f7f32f1e55cc028109c.svg";
export { ForwardRef as ReactComponent };